/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_One_Thing_TitleInputs */

const es_prompt_tips_one_thing_title = /** @type {(inputs: Prompt_Tips_One_Thing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedí una cosa a la vez`)
};

const en_prompt_tips_one_thing_title = /** @type {(inputs: Prompt_Tips_One_Thing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask for one thing at a time`)
};

/**
* | output |
* | --- |
* | "Ask for one thing at a time" |
*
* @param {Prompt_Tips_One_Thing_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_one_thing_title = /** @type {((inputs?: Prompt_Tips_One_Thing_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_One_Thing_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_one_thing_title(inputs)
	return en_prompt_tips_one_thing_title(inputs)
});
export { prompt_tips_one_thing_title as "prompt_tips.one_thing_title" }